<template>
  <v-container>
    <v-row>
      <v-col>
        <h1>RAferral QR Codes & Nametags</h1>
        <v-divider class="py-3" />
      </v-col>
    </v-row>

    <v-row v-if="pages">
      <v-col cols="12">
        <v-sheet elevation="1" class="pa-4" rounded>
          <v-row>
            <v-col md="6">
              <v-text-field
                v-model="search"
                label="Search by Employee Name"
                outlined
                dense
                clearable
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row justify="middle" v-if="isFindPending">
            <v-col class="text-center">
              <heart-loader />
            </v-col>
          </v-row>
          <v-row v-if="!isFindPending && pages">
            <v-col cols="12">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>Employee</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="page in filteredPages"
                      :key="page.id"
                      @click="openModal($event, page)"
                      style="cursor: pointer;"
                    >
                      <td>{{page.employeeFullName}}</td>
                      <td class="text-right"><v-btn icon depressed @click.prevent="openModal($event, page)"><v-icon>open_in_new</v-icon></v-btn></td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>
    </v-row>

    <v-dialog v-model="showModal" max-width="800px">
      <v-card v-if="currentPage">
        <v-card-title>
          <h2>{{ currentPage.employeeFullName }}</h2>
        </v-card-title>
        <v-divider class="py-3"></v-divider>

        <v-card-text>
          <v-row>
            <v-col cols="12" md="6">
              <h3>QR Code</h3>
              <img :src="currentPage.qrCodeUrl" alt="QR Code" />
            </v-col>

            <v-col cols="12" md="6">
              <v-row>
                <v-col cols="12">
                  <h3>Nametag</h3>
                  <img :src="`https://ra-ecco-storage.s3.us-west-2.amazonaws.com/referral/${currentPage.employeeId}-nametag.png`" alt="Nametag" />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-btn
                    :href="`https://ra-ecco-storage.s3.us-west-2.amazonaws.com/referral/${currentPage.employeeId}-nametag.png`"
                    target="_blank"
                    color="primary"
                    :download="getFileName(currentPage.employeeFullName)"
                    outlined
                  >
                    Download Nametag
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="showModal = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import heartLoader from '../components/heartLoader.vue'

export default {
  components: { heartLoader },
  name: 'RaferralQRNametags',
  data: () => ({
    showModal: false,
    currentPage: null,
    search: '',
  }),

  computed: {
    ...mapGetters({
      pages: 'referral-page/list'
    }),
    isFindPending() {
      return this.$store.state['referral-page'].isFindPending
    },
    filteredPages() {
      if (!this.search) return this.pages
      const searchLower = this.search.toLowerCase()
      return this.pages.filter(page => page.employeeFullName.toLowerCase().includes(searchLower))
    }
  },

  methods: {
    openModal($event, page) {
      this.showModal = true
      this.currentPage = page
    },
    getFileName(fullName) {
      return `${fullName.replace(/\s+/g, '_')}_nametag.png`
    },
    getData() {
      this.$store.dispatch('referral-page/find', {
        query: {
          $limit: 500,
          $sort: { employeeFullName: 1 },
        }
      })
    }
  },

  mounted() {
    this.getData()
  }
}
</script>

<style lang="sass">

</style>